export default {
  // 工作臺
  workbench: {
    introduction: '可視化的組織工具,可以幫助您更快,更準確地管理和監督項目的開發',
    addmemo: '新增備忘錄',
    overdue: '超時待辦',
    today: '今日待辦',
    tomorrow: '明日要做',
    later: '以後要做',
    allToDo: '全部待辦',
    overduenote: '截止今日超期任務',
    todaynote: '截止今日需要完成任務',
    tomorrownote: '明日需要完成任務',
    laternote: '未來任務安排',
    taskError: '請輸入任務名稱！',
    addschedule: '新建日程',
    switchColleagues: '切換同事',
    soOn: '等',
    people: '人',
    individual: '個人',
    executor: '執行人',
    endtime: '設置截止時間',
    inputname: '請輸入任務名稱',
    leave: '請假單',
    overtime: '加班申請單',
    memonote1: '今天在客戶現場,客戶就產品的質量問題提出了自己的建議,在我們貨運過程中...',
    memonote2: '銷售反饋問題：1、在客戶界面下,客戶的優先級要通過顏色進行標識,下次聯系...',
    memonote3: '數據分析統計是根據對比和階段數據來呈現銷售的業績軌跡,如果在我們沒有...',
    duty_name: '員工',
    member: '成員姓名',
    name: '名稱',
    visibleMember: '可見成員',
    addMember: '可見成員',
    modifier: '修改人',
    edittime: '修改時間',
    status: '狀態',
    operation: '操作',
    disableTip: '確定要禁用該門戶嗎？',
    enableTip: '確定要啟用該門戶嗎？',
    deleteTip: '確定要刪除該門戶嗎？',
    workset: '工作臺設置',
    workName: '工作臺名稱',
    set: '設置',
    pagelayout: '頁面布局',
    customcomponent: '自定義組件',
    advancedcomponent: '高級類組件',
    last: '上壹步',
    next: '下壹步',
    namerestriction: '門戶名稱限制12字內',
    workname_empty: '工作臺名稱不能為空',
    taskShow: '任務顯示',
    showstyle: '顯示樣式',
    showT: '單獨顯示任務',
    showTS: '顯示任務和日程',
    show: '顯示',
    tasklist: '任務列表',
    view: '視圖',
    submenu: '子菜單',
    custommodule: '自定義模塊',
    submenuname: '子菜單名稱',
    customapp: '自定義應用',
    customapp_empty: '自定義應用不能為空',
    custommodule_empty: '自定義模塊不能為空',
    submenu_empty: '子菜單名稱不能為空',
    name_empty: '名稱不能為空',
    chart: '圖表',
    project: '項目',
    allCustomer: '全部客戶',
    szHighSeasPool: '深圳公海池',
    shHighSeasPool: '上海公海池',
    bjHighSeasPool: '北京公海池',
    gzHighSeasPool: '廣州公海池',
    ym: 'yyyy年MM月',
    time: '時間',
    enclosure: '附件',
    remind: '提醒',
    noRemind: '不提醒',
    beforeStartTime: '起始時間前',
    participant: '參與人',
    startTime: '起止日期',
    addAttachment: '添加附件',
    viewScheduleAssistant: '查看日程排期小助手',
    startTime_empty: '開始時間不能為空',
    endTime_empty: '結束時間不能為空',
    time_error: '開始時間不能大於或等於結束時間',
    remindTime_empty: '提醒時間不能為空',
    fileSize: '每個附件大小不得超過20MB',
    businessprocess: '業務流程',
    datalist: '數據列表',
    total: '共',
    a: '項',
    beginnerboot: '新手引導',
    watchvideointroduction: '觀看視頻介紹',
    exploretheteamfaceapp: '探索應用',
    createformprocessdataanalysis: '創建表單/流程/數據報表',
    invitemembers: '邀請成員',
    guide1: '1/4 是壹個企業數據管理壹體化平臺系統,簡單好用易上手,系統預置的固定模塊打開即用。',
    guide2: '2/4 擁有豐富的業務應用和行業應用,壹鍵安裝,立即實現您的管理訴求。',
    guide3: '3/4 想要自由創建您的專屬系統？3分鐘帶妳實現從0到1搭建貼合您企業需求的定制系統。',
    guide4: '4/4 想要實現深度定制？壹對壹專屬定制顧問將竭誠為您服務~',
    guide5: '1/4  從0開始布局,拖拉拽搭建,自由定義每壹個模塊。',
    guide6: '2/4 創建的應用模塊可根據企業不同的應用場景進行流程自定義設置,如報銷、請假、申請等。',
    guide7:
      '3/4 企業流程由系統自動化運行,智能觸發計劃好的業務步驟,實現工作高效化、數據可視化、流程精細化管理。',
    guide8: '4/4 根據實際需要,可自由定義想查看的數據類型,數據範圍,數據統計報表呈現樣式等。',
    experienceitnow: '立即體驗',
    datetimedisplay: '日期時間顯示',
    headingtext: '標題文字',
    contenttextclickmoreadddata: '內容文字,點擊更多添加數據',
    announcementtitle: '公告標題',
    announcementcontenttip: '公告內容,點擊在右邊增加數據來源',
    today3: '今',
    overdue2: '超期·',
    today2: '今日·',
    tomorrow2: '明日·',
    later2: '以後·',
    completed2: '已完成·',
    seemore: '查看更多…',
    selectviewrange: '選擇查看範圍',
    unfinished: '未完成',
    selectviewer: '選擇查看人員',
    allitems: '全部項目',
    calendarview: '日歷視圖',
    teamstatus: '團隊狀態',
    unknowntime: '未知時間',
    contentdeleteTip: '這是壹段內容這是壹段內容確定刪除嗎？',
    addmembersmanually: '手動添加成員',
    individualtasks: '個人任務',
    draft: '草稿',

    schedulesharing: '日程共享',
    portalname: '門戶名稱',
    schedulesharingsettings: '日程共享設置',
    schedulesharingsettingsTip:
      '通過設置可以將某個成員、部門或角色的日程共享給其他人,其他人可通過日程進行查看。',
    serialnumber: '序號',
    shareer: '共享者',
    shareto: '共享給',
    newagendasharing: '新建日程共享',
    editportal: '編輯門戶',
    createportal: '創建門戶',
    portalicon: '門戶圖標',
    selecticon: '選擇圖標',
    portalnamecannotbeempty: '門戶名稱不能為空',
    visiblemembercannotbeempty: '可見成員不能為空',
    sharewaremustfill: '共享者必填',
    sharedtorequired: '共享給必填',
    editingportal: '正在編輯門戶：',
    portalinterfaceconfiguration: '門戶界面配置',
    selectbase: '選擇底圖',
    nobase: '無底圖',
    basetype: '底圖類型',
    color: '顏色',
    uploadimage: '上傳圖片',
    imagesisrecommende: '建議使用1920*1080或更大尺寸的圖片限5M',
    addimage: '添加圖片',
    backgroundimagedisplaymode: '背景圖顯示方式',
    selectcolor: '選擇顏色',
    restoredefault: '恢復默認',
    selectouterbox: '選擇外框',
    title: '標題',
    headingfont: '標題字體',
    titlebackground: '標題背景',
    background: '背景',
    backgroundsettings: '背景設置',
    frame: '外框',
    outsidebox: '欄目外框',
    layout: '布局',
    selectlayout: '選擇布局',
    component: '組件',
    theme: '主題',
    transparenttheme: '透明主題',
    freelayout: '自由布局',
    onecolumnlayout: '壹欄布局',
    twocolumnlayout: '二欄布局',
    threecolumnlayout: '三欄布局',
    otherlayouts: '其他布局',
    wheelplot: '輪播圖',
    tabswitch: 'Tab切換',
    columnone: '欄目壹',
    column2: '欄目二',
    quickaccess: '快捷入口',
    shortcutbutton: '快捷按鈕',
    shortcutbuttonone: '快捷按鈕壹',
    shortcutbutton2: '快捷按鈕二',
    graphic: '圖文',
    announcements: '公告',
    statistics: '統計',
    projectmanagement: '項目管理',
    lanemap: '泳道圖',
    embeddedurl: '嵌入URL',
    filesizemustnotexceed5mb: '文件大小不得超過5MB',
    image_empty: '【圖片】內容不能為空',
    slidesnumber_empty: '【輪播圖】數量不能為空',
    slidescontent_empty: '【輪播圖】內容不能為空',
    video_empty: '【視頻】內容不能為空',
    tabsnum_empty: '【Tab切換】數量不能為空',
    tabscontent_empty: '【Tab切換】操作內容不能為空',
    quickentrynum_empty: '【快捷入口】數量不能為空',
    quickentrycontent_empty: '【快捷入口】操作內容不能為空',
    imagetextitem_empty: '【圖文】欄目名稱不能為空',
    imagetextcontent_empty: '【圖文】內容來源模塊不能為空',
    imagetexttitle_empty: '【圖文】標題不能為空',
    imagetextimage_empty: '【圖文】圖片不能為空',
    noticecontent_empty: '【公告】內容來源模塊不能為空',
    noticetitle_empty: '【公告】標題不能為空',
    noticecontent2_empty: '【公告】內容不能為空',
    viewnum_empty: '【視圖】數量不能為空',
    chartname_empty: '【統計】數據分析表單名稱不能為空',
    chart_empty: '【統計】圖表不能為空',
    url_empty: '【嵌入URL】url不能為空',
    sharepermissions: '共享權限',
    readonly: '只讀',
    imagesettings: '圖片設置',
    imagecontent: '圖片內容',
    linkaddress: '鏈接地址',
    picturetext: '圖片文字',
    imagedisplaymode: '圖片顯示方式',
    rotationsset: '輪播圖設置',
    numberofrotationplots: '輪播圖數量',
    addupto5images: '最多添加5張圖片',
    videosettings: '視頻設置',
    videodisplay: '視頻顯示',
    notitle: '無標題',
    withatitle: '有標題',
    addvideo: '添加視頻',
    videoaddress: '視頻地址',
    localupload: '本地上傳',
    supporttencentyouku: '支持騰訊、優酷視頻。',
    localvideo: '本地視頻',
    videodisplaymode: '視頻顯示方式',
    tabtogglesettings: 'Tab切換設置',
    styleselection: '風格選擇',
    tabcolumn: 'Tab欄目',
    tabcolumnone: 'Tab欄目壹',
    tabcolumn2: 'Tab欄目二',
    tabcolumn3: 'Tab欄目三',
    tabswitchnumber: 'Tab切換數量',
    addupto10tabs: 'Tab數量最多添加10個',
    shortcutentrysettings: '快捷入口設置',
    shortcutstyle: '快捷操作樣式',
    button: '按鈕',
    entrance: '入口',
    singlebuttonwidth: '單個按鈕寬度',
    equal: '等分',
    adaptivetext: '自適應文字',
    backgroundcolor: '背景顏色',
    displaystyle: '展示樣式',
    defaultstyle: '默認樣式',
    adddivider: '加分隔線',
    numberofrows: '單行數量',
    addoperation: '添加操作',
    graphicsettings: '圖文設置',
    columnname: '欄目名稱',
    displaytype: '展示類型',
    text: '文本',
    graphictypestructure: '圖文類型結構',
    around: '左右',
    upanddown: '上下',
    texttype: '文本類型',
    titlecontent: '標題+內容',
    displaycolumncount: '顯示列數',
    displayheight: '顯示高度',
    graphicratio: '圖文占比',
    textposition: '文字位置',
    totheleft: '居左',
    centered: '居中',
    totheright: '居右',
    graphiccontentsourcemodule: '圖文內容來源模塊',
    correspondingdisplayfield: '對應顯示字段',
    announcementsettings: '公告設置',
    banner: '橫幅',
    panel: '面板',
    runningupanddownthelantern: '上下跑馬燈',
    runninghorselampleftandright: '左右跑馬燈',
    showtitle: '展示標題',
    paneldisplay: '面板顯示',
    singledata: '單條數據',
    multipledata: '多條數據',
    bulletindisplaynumber: '公告展示條數',
    viewsettings: '視圖設置',
    textdisplaystructure: '文字顯示結構',
    singlecolumn: '單列',
    doublecolumn: '雙列',
    statisticssettings: '統計設置',
    dataanalysisformname: '數據分析表單名稱',
    numericalappearanceadjustment: '數值外觀調整',
    default: '默認',
    fontcolor: '字體顏色',
    embeddedurlsettings: '嵌入URL設置',
    enterurl: '輸入URL',
    schedulesettings: '日程設置',
    columnnamelocation: '欄目名稱位置',
    displaycontent: '展示內容',
    swimlanemapsettings: '泳道圖設置',
    displaynumberofrows: '顯示行數',
    selectdata: '選擇數據',
    addbutton: '添加按鈕',
    performoperations: '執行操作',
    operationcontent: '操作內容',
    buttonname: '按鈕名稱',
    icon: '圖標',
    newdata: '新增數據',
    opensubmenu: '打開子菜單',
    openlink: '打開鏈接',
    repeatedsubmenu: '子菜單已重復',
    datasourcecannotbenull: '數據來源不能為空',
    columnnamecannotbeempty: '欄目名稱不能為空',
    buttonnamecannotbeempty: '按鈕名稱不能為空',
    linkaddresscannotbeempty: '鏈接地址不能為空',
    operationcontentcannotbeempty: '操作內容不能為空',
    style1: '樣式壹',
    style2: '樣式二',
    empty: '空',
    newtype: '新增類型',
    createdIn: '創建於',
    // 20210715
    deptask: '部门任务',
    degreeemergency: '紧急程度',
    // 20220412
    lastmonth: '上個月',
    nextmonth: '下個月',
    basicapplication: '基礎應用',
    customapplication: '定制應用',
    welcomeunlockTF: '歡迎一起來解鎖！',
    step1: '第一步',
    step2: '第二步',
    step3: '第三步',
    step4: '第四步',
    firstmeetTF: '初識我们',
    whatcanTFdoforyou: '可為您做什麼',
    learnabouttfapplication: '瞭解應用',
    iftfapplicationbuilt: '如果搭建應用',
    createfirstapplication: '創建第一個應用',
    practicefromfield: '從範本創建練練手',
    howfindmyapp: '如何找到我的應用',
    finishopeningpreviousstep: '完成上一步教程後才可開啟此教程',
    closeafterreading: '請看完新手引導後再關閉',
    field: '123123123',
    backlogData: '待辦數據',
    pendingTask: '待處理任務',
    processedTask: '已處理任務',
    toBeProcessed: '待處理',
    pendingApprovalProcess: '待處理審批流程',
    businesstobeprocessed: '待處理業務流程',
    attendanceTobeconfirmed: '待確認考勤',
    pendingPerformanceReview: '待處理績效考核',
    pendingPayrollPpproval: '待處理薪酬審批',
    customapptobeprocessed: '待處理定製應用',
    owningModule: '所屬模塊',
    nodeArrivalTime: '節點到達時間',
    TaskStartEndTime: '任務起止時間',
    confirmationDeadline: '確認截止時間',
    assessmentName: '考核名稱',
    assessor: '考核人',
    assessmentCycle: '考核周期',
    CurrentStage: '當前階段',
    payName: '薪酬名稱',
    searchTitle: '搜索標題',
    SearchTaskName: '搜索任務名稱',
    SearchAttendanceName: '搜索考勤名稱',
    SearchTestName: '搜索考核名稱',
    SearchSalaryName: '搜索薪酬名稱',
    allDay: '全天',
    change: '更改',
    customRepeat: '自定義重復',
    repeatTate: '重復頻率',
    endRepeat: '結束重復',
    notRepeat: '不重復',
    everyDayRepeat: '每個工作日重復',
    limitedDegree: '限定次數',
    neverEnd: '永不截止',
    repeatTateNotEmpty: '重復頻率不能為空',
    repeatTateError: '重復頻率格式錯誤',
    deadlineNotEmpty: '截止時間不能為空',
    degreeEmpty: '限定次數不能為空',
    degreeError: '限定次數格式錯誤',
    deleteBacklog: '確定要刪除該待辦嗎？',
    batchDelete: '批量刪除',
    cutomAppTips:
      '僅用於對前端【定製應用】的待辦數據刪除處理，刪除後負責人的待辦事項將不會在顯示，此操作不可恢復（其余類型待辦數據同數據實時同步，從原始數據處理即可）。',
    schedule: '日程',
    effectiveTime: '生效時間',
    every: '每個',
    everyWorkingDay: '每個工作日',
    mondayToFriday: '星期一至星期五',
    terminationRepeat: '次後終止重復',
    pleaseInputPhoneNo: '請輸入電話號碼',
    noDataFound: '未搜索到數據',
    searching: '搜索中...'
  }
}
